import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { AnyIfEmpty } from "react-redux";

export interface IGroupeFonctionnaliteState {
  groupeFonctionnalites: IGroupeFonctionnalite[];
  groupeFonctionnalitesBySousModule: IGroupeFonctionnalite[];
  objGroupeFonctionnalite: IGroupeFonctionnalite;
  openDialogGF: boolean;
  valueEdit:string;
}

export interface IGroupeFonctionnalite {
  idModule: string;
  idSousModule: string;
  idGroupeFonctionnalite: string;
  libelleGroupeFonctionnalite: string;
}



export const groupeFonctionnaliteSlice: any = createSlice({
  name: "groupeFonctionnalite",
  initialState: {
    openDialogGF: false,
    groupeFonctionnalites: [],
    objGroupeFonctionnalite: {},
    groupeFonctionnalitesBySousModule: [],
    valueEdit:""
  },
  reducers: {

    addGroupeFonctionnalites: (state, action) => {
      const newGroupeFonctionnalite: any = [...state.groupeFonctionnalites, action.payload]
      state.groupeFonctionnalites = newGroupeFonctionnalite;
    },

    setGroupeFonctionnalites: (state, action) => {
      state.groupeFonctionnalites = action.payload;
    },

    setObjGroupeFonctionnalite: (state, action) => {
      state.objGroupeFonctionnalite = action.payload;
    },

    setGroupeFonctionnalitesBySousModule: (state, action) => {
      state.groupeFonctionnalitesBySousModule = action.payload;
    },

    setOpenDialogGF: (state, action) => {
      state.openDialogGF = action.payload;
    },

    deleteGroupeFonctionnalite: (state, action) => {
      state.groupeFonctionnalites = state.groupeFonctionnalites.filter((gf: IGroupeFonctionnalite) => gf.idSousModule !== action.payload);
    },

    editGroupeFonctionnalite: (state, action) => {
      const newGF: any = state.groupeFonctionnalites.map((gf: IGroupeFonctionnalite) => (gf.idSousModule === action.payload.idSousModule ? action.payload : gf))
      state.groupeFonctionnalites = newGF;
    },

    setValueEdit: (state, action) => {
      state.valueEdit = action.payload;
    },

  }
});

export const {
  setOpenDialogGF,
  addGroupeFonctionnalites,
  setGroupeFonctionnalites,
  setObjGroupeFonctionnalite,
  setGroupeFonctionnalitesBySousModule,
  deleteGroupeFonctionnalite,
  editGroupeFonctionnalite,
  setValueEdit
} = groupeFonctionnaliteSlice.actions;


export default groupeFonctionnaliteSlice.reducer;
